<div class="onmat-errors">
  <header class="onmat-errors__header">
    <svg-icon key="logo-onmat" class="onmat-errors__logo"></svg-icon>
  </header>
  <div class="flex justify-center items-center">
    <div class="onmat-errors__body">
      <img src="/assets/errors/No-puedes-ver-actividad.png" class="onmat-errors__image" />
      <div class="error-message">
        <h1 class="error-message__title" translate>f.error-page.not-found.title</h1>
        <p class="error-message__text" translate>f.error-page.not-found.description</p>
        <a href="#" class="error-message__button btn btn-primary" translate>
          <svg-icon key="icon-refresh" class="error-message__icon"></svg-icon>
          f.error-page.not-found.button.message</a
        >
      </div>
    </div>
  </div>
</div>
